const map = {
	"./g-1.png": 34010,
	"./g-2.png": 58673,
	"./g-3.png": 18728,
	"./g-4.png": 93895,
	"./g-5.png": 22558,
	"./g-6.png": 8309,
	"./g-7.png": 25420,
	"./g-8.png": 5307,
	"./g-9.png": 56306,
	"assets/img/g-images/g-1.png": 34010,
	"assets/img/g-images/g-2.png": 58673,
	"assets/img/g-images/g-3.png": 18728,
	"assets/img/g-images/g-4.png": 93895,
	"assets/img/g-images/g-5.png": 22558,
	"assets/img/g-images/g-6.png": 8309,
	"assets/img/g-images/g-7.png": 25420,
	"assets/img/g-images/g-8.png": 5307,
	"assets/img/g-images/g-9.png": 56306
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19594;